import { makeAutoObservable } from "mobx";

const MAX_PLAYER_INFO_EVENTS_PER_SERVER = 500;

export default class PlayerStore {
    constructor() {
        this._playerInfo = {};
        this._playerCount = {};

        makeAutoObservable(this);
    }

    setPlayerInfo(storage) {
        const { player_info, data } = storage || {};

        if (typeof player_info === "undefined" || player_info === null || !Array.isArray(data)) {
            console.warn("Некорректные данные для setPlayerInfo:", storage);
            return;
        }

        const currentInfo = this._playerInfo[player_info] || { player_info, data: [] };

        this._playerInfo = {
            ...this._playerInfo,
            [player_info]: {
                player_info,
                data: currentInfo.data.concat(data).slice(-MAX_PLAYER_INFO_EVENTS_PER_SERVER),
            },
        };

        this._playerCount = {
            ...this._playerCount,
            [player_info]: {
                player_info,
                data,
            },
        };
    }

    getStorageByPlayerInfoId(playerInfoId) {
        return this._playerInfo[playerInfoId] || { player_info: playerInfoId, data: [] };
    }

    reset() {
        this._playerInfo = {};
        this._playerCount = {};
    }

    get player_info() {
        return this._playerInfo;
    }

    get player_count() {
        return this._playerCount;
    }
}
